import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { iconCoupling, iconCouplingCanton } from '../Constants/ConstantsOptics';
import useZoomLevel from './useZoomLevel'; 

const MarkersEditingCoupling = ({ markers, selectedRankCouling, removeMarker, type }) => {
 
  const selectedIcon = selectedRankCouling === '1' || selectedRankCouling === '2' ? iconCoupling : iconCouplingCanton;
  const zoomLevel = useZoomLevel();

  if (zoomLevel <= 15) {
    return null;
  }

  return (  
  <>
    {markers.map((marker, index) => (
      <Marker
        key={index}
        position={[marker.lat, marker.lng]}
        icon={selectedIcon}
      >
        <Popup autoClose={false} className="custom-popup">
          <div>
            <label style={{ color: '#555555', fontSize: '16px' }}>{type}</label>
            <hr className="horizontalLinePopup" />
            <button className="popupButtonDelete" onClick={(e) => { e.stopPropagation(); removeMarker(index); }}>Удалить маркер</button>
          </div>
        </Popup>
      </Marker>
    ))}
  </>
  );
}
export default MarkersEditingCoupling;
